export function convertYYYYMMDDtoDDMMYYYY(date: string){
    let dateArray = date.toString().split('-');
    date = dateArray[2]?.toString().trim() +'-'+ dateArray[1]?.toString().trim() +'-'+ dateArray[0]?.toString().trim();
    return date;
}